import React from "react";
import PropTypes from "prop-types";

import SideContentTemplate from "../SideContentTemplate";

const GetOnBoard = ({ content, btnClassNames }) => {
  return (
    <>
      {content && (
        <SideContentTemplate
          backgroundImg="get-on-board"
          backgroundColor="blue"
          headerHTML={content.pHeading}
          contentHTML={content.pContent}
          signupBtnLabel={content.pButtonText}
          signupBtnLinkOverride={content.pButtonUrl}
          signupBtnClassNames={btnClassNames}
          isContentCentered={true}
          isPartialCentered={true}
        />
      )}
    </>
  );
};

GetOnBoard.propTypes = {
  content: PropTypes.any,
  btnClassNames: PropTypes.string,
};

GetOnBoard.defaultProps = {
  btnClassNames: "button-primary",
};

export default GetOnBoard;
